<div class="body ui container fluid" fxLayout="column" fxLayoutAlign="flex-start none">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
            <div>
                <img src="assets/icons/left-arrow-icon.svg" alt="" />
            </div>
            <div class="equipment-id">
                <!-- Title -->
                <label class="ui grey">Home / Settings / Application Security</label>
                <h2 class="ui primary header">File Upload</h2>
            </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
    <div class="ui secondary pointing menu sub">
        <div class="ui item" [routerLink]="['./dashboard']" routerLinkActive="active">
            Dashboard
        </div>
        <div class="ui item" [routerLink]="['./logs']" routerLinkActive="active">
            All File Logs
        </div>
        <div class="ui item" [routerLink]="['./settings']" routerLinkActive="active">
            File Upload Settings
        </div>
    </div>
    <router-outlet></router-outlet>
</div>